import style from '../../styles/components/newsletter/newsletter-page'

const InputEmail = ({ email, onEmailChange, helperText }) => {
  return (
    <div className='email-container'>
      <div className='title'>Email Address:</div>
      <input autoFocus={true} className='input' type='text' value={email} onChange={onEmailChange} />
      {helperText && <span className='helper-text'>{helperText}</span>}
      <style jsx global>
        {style}
      </style>
    </div>
  )
}

export default InputEmail
